// src/components/infografia/properties/LayerControls.jsx
import React from 'react';
import { FaArrowUp, FaArrowDown, FaAngleDoubleUp, FaAngleDoubleDown } from 'react-icons/fa';

const LayerControls = ({ element, onLayerChange }) => {
    const handleBringToFront = () => {
        onLayerChange('toFront');
    };

    const handleBringForward = () => {
        onLayerChange('forward');
    };

    const handleSendBackward = () => {
        onLayerChange('backward');
    };

    const handleSendToBack = () => {
        onLayerChange('toBack');
    };

    return (
        <div className="space-y-4">
            <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                    Control de Capas
                </label>
                <div className="grid grid-cols-2 gap-2">
                    <button
                        onClick={handleBringToFront}
                        className="flex items-center justify-center gap-2 px-3 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-colors"
                        title="Traer al frente"
                    >
                        <FaAngleDoubleUp />
                        <span className="text-xs">Al frente</span>
                    </button>
                    <button
                        onClick={handleBringForward}
                        className="flex items-center justify-center gap-2 px-3 py-2 bg-blue-400 text-white rounded-md hover:bg-blue-500 transition-colors"
                        title="Subir una capa"
                    >
                        <FaArrowUp />
                        <span className="text-xs">Subir</span>
                    </button>
                    <button
                        onClick={handleSendToBack}
                        className="flex items-center justify-center gap-2 px-3 py-2 bg-gray-500 text-white rounded-md hover:bg-gray-600 transition-colors"
                        title="Enviar al fondo"
                    >
                        <FaAngleDoubleDown />
                        <span className="text-xs">Al fondo</span>
                    </button>
                    <button
                        onClick={handleSendBackward}
                        className="flex items-center justify-center gap-2 px-3 py-2 bg-gray-400 text-white rounded-md hover:bg-gray-500 transition-colors"
                        title="Bajar una capa"
                    >
                        <FaArrowDown />
                        <span className="text-xs">Bajar</span>
                    </button>
                </div>
            </div>
            <div className="text-xs text-gray-500 bg-gray-50 p-2 rounded">
                <p><strong>Tip:</strong> Las capas determinan qué elementos aparecen encima de otros.</p>
            </div>
        </div>
    );
};

export default LayerControls;

